export default __webpack_public_path__ + "static/media/0xe86e8beb7340659dddce61727e500e3a5ad75a90.9a81c3d0.png";